/* eslint-disable react/require-default-props */
import * as React from "react";
import { cx, css } from "@emotion/css";

interface GeneralButtonProps {
  buttonType: "primary" | "secondary";
  disabled?: boolean;
  text: string;
  id: string;
  onClick?: (e: React.SyntheticEvent) => void;
}

const btnClass = css`
  border: 0;
  padding: 12px;
  text-shadow: none;
  font-size: 1em;
  line-height: 1em;
  border-radius: 3px;
  font-size: 0.85em;
  text-transform: uppercase;

  :active {
    box-shadow: none;
  }
`;

const primaryBtnClass = css`
  background: #007eb7;
  color: #fff;
  font-size: 15px;
  text-transform: uppercase;

  :hover {
    background: #0098d0;
    text-shadow: none;
    color: #fff;
  }
`;

const btnOutlineClass = css`
  border: 1px solid #007eb7;
  border-radius: 3px;
  color: #007eb7;
`;

const secondaryBtnClass = css`
  background: #fff;
  color: #007eb7;

  :hover {
    text-decoration: underline;
    color: #0098d0;
  }
`;

const primaryDisabledClass = css`
  background: #dfd9d9;
  color: #8a9191;
`;

export const GeneralButton = ({
  id,
  buttonType,
  disabled = false,
  text,
  onClick,
  ...rest
}: GeneralButtonProps) => {
  return (
    <button
      id={id}
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={cx(
        btnClass,
        {
          [btnOutlineClass]: !disabled
        },
        {
          [primaryBtnClass]: buttonType === "primary"
        },
        {
          [secondaryBtnClass]: buttonType === "secondary"
        },
        {
          [primaryDisabledClass]: buttonType === "primary" && disabled
        }
      )}
      {...rest}
    >
      {text}
    </button>
  );
};
